export const API_KEY =
  'cddf71edac33700dffe5b01b3a0eddc549e4e59f09df3205b4fdfb0910fa49e6';
export const ColorGridTitle = 'Color gradient grid';
export const ImageGridTitle = 'Related color lists.';
export const LOADING = 'loading...';
